import Head from "next/head";
import Link from "next/link";

import FlashPCBMarkdown from "../FlashPCBMarkdown";

import {
  StaticDocs,
  SidebarContentLink,
  DocsPageProps,
} from "../../utils/docs";
import { DOCS } from "../../constants/routes";
import { headerTitleToId } from "../FlashPCBMarkdown/constants";
import * as styledElements from "./DocsStyles";
import {
  numberToWords,
  twentyFourHourToTwelveHour,
} from "../../utils/valueFormatting";

const renderContentLinks = (
  contentLinks: SidebarContentLink[],
  pageLink: string,
) => (
  <styledElements.SidebarList useLeftMargin>
    {contentLinks.map((contentLink, itemIndex) => {
      const id = headerTitleToId(contentLink.title);
      return (
        <styledElements.SidebarListItem key={`${id} ${itemIndex}`}>
          <Link href={`${pageLink}#${id}`} passHref>
            {contentLink.title}
          </Link>
        </styledElements.SidebarListItem>
      );
    })}
  </styledElements.SidebarList>
);

const renderSidebar = (sidebar: StaticDocs) => (
  <styledElements.SidebarList useLeftMargin>
    {sidebar.pages.map((page, itemIndex) => {
      const pageLink = `${DOCS}/${page.slug}`;
      return (
        <styledElements.SidebarListItem key={`${page.title} ${itemIndex}`}>
          <Link href={pageLink} passHref>
            {page.title}
          </Link>
          {page.contentLinks &&
            page.contentLinks.length > 0 &&
            renderContentLinks(page.contentLinks, pageLink)}
        </styledElements.SidebarListItem>
      );
    })}
  </styledElements.SidebarList>
);

const Docs = ({
  title,
  staticDocs,
  markdown,
  flashPCBSettings,
}: DocsPageProps) => {
  const docsVariables = {
    flashpcb_address_name: flashPCBSettings.flashpcb_address.name,
    flashpcb_address_street_address:
      flashPCBSettings.flashpcb_address.street_address,
    flashpcb_address_last_line: flashPCBSettings.flashpcb_address.last_line,
    quote_expiry_days: numberToWords(flashPCBSettings.quote_expiry_days),
    local_lead_time_eod: twentyFourHourToTwelveHour(
      flashPCBSettings.local_lead_time_eod,
    ),
  };

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content="FlashPCB documentation" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <styledElements.Container>
        <styledElements.SidebarElement>
          <styledElements.SidebarTitle>
            Documentation
          </styledElements.SidebarTitle>
          {renderSidebar(staticDocs)}
        </styledElements.SidebarElement>
        <styledElements.Body>
          <FlashPCBMarkdown
            markdown={markdown}
            externalLinks={(href) => !href.startsWith(DOCS)}
            data={docsVariables}
          />
        </styledElements.Body>
      </styledElements.Container>
    </>
  );
};

export default Docs;
